import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from './Autocomplete.js';

import styles from './AutocompleteWrapper.module.scss';

const THRESHOLD_SCROLL_UP = 10;
const THRESHOLD_TOP = 138;

const AutocompleteWrapper = (props) => {

    const [isOpen, setIsOpen] = useState(false);
    const [prevScroll, setPrevScroll] = useState(0);
    const [isVisible, setIsVisible] = useState(true);

    // istanbul ignore next
    const handleScroll = () => {
        /* eslint-disable-next-line no-undef */
        const currentPos = window.pageYOffset;
        const isScrollUp = prevScroll > currentPos;
        const isScrollDw = currentPos < THRESHOLD_TOP;
        const diff = prevScroll - currentPos > THRESHOLD_SCROLL_UP;
        setIsVisible(!prevScroll || isVisible && isScrollUp || !isVisible && isScrollUp && diff || isScrollDw);
        setPrevScroll(currentPos);
    };

    useEffect(() => {
        /* eslint-disable no-undef */
        window.addEventListener('scroll', handleScroll);
        return () => { window.removeEventListener('scroll', handleScroll); };
        /* eslint-enable no-undef */
    }, [prevScroll, isVisible, handleScroll]);

    useEffect(() => {
        /* istanbul ignore next */
        props.onTopHeaderVisible && props.onTopHeaderVisible(isOpen);
    }, [isOpen]);

    return (
        <div className={`${styles[`autocomplete-wrapper-component`]} ${ /* istanbul ignore next */ !isOpen && !isVisible ? styles['is-hidden'] : ''}`}>
            <Autocomplete {...props} onOpen={setIsOpen} />
        </div>
    );
};

AutocompleteWrapper.propTypes = {
    onTopHeaderVisible: PropTypes.func,
};

export default AutocompleteWrapper;
